import { useTranslation } from 'react-i18next'

import { SeoProps } from '../components/Seo'

const useSEO = (): SeoProps => {
  const { t } = useTranslation()

  return {
    applicationName: t('applicationName'),
    title: t('seo_title'),
    description: t('seo_description'),
  }
}

export default useSEO
